export default {
    usageManagement: {
        page: {
            title: '系統管理中心',
            description: '管理使用者使用量、模型設定、工具設定和 Langfuse Prompt',
        },
        tabs: {
            overview: '會話監控',
            usage: '使用者使用量',
            model: '模型設定',
            tool: '工具設定',
            prompt: 'Prompt 管理',
            feedback: 'Feedback 管理',
            payment: '支付統計',
            tokenUsage: 'Token 使用量',
            report: '統計報表',
            userActivityReport: '日活報表',
            assetStats: '資產統計',
            documentStats: '文件統計',
            skill: 'Skill 管理',
            role: '人員管理',
        },
        overview: {
            metrics: {
                totalSessions: '總會話數',
                avgDuration: '平均會話時長',
                avgRounds: '平均對話輪數',
                successRate: '任務成功率',
                activeUsers: '活躍使用者數',
            },
            date: { today: '今天', yesterday: '昨天', last3days: '最近3天', last7days: '最近7天' },
            refresh: '重新整理',
            table: {
                sessionId: '會話ID', user: '使用者', email: '電子郵件', ip: '歸屬地',
                rounds: '對話輪數', duration: '持續時長', successFailure: '成功/失敗',
                startTime: '開始時間', copy: '複製', intranet: '內網',
            },
            drawer: {
                title: '會話詳情', sessionId: '會話ID', user: '使用者', email: '電子郵件',
                taskId: '任務ID', status: '狀態', ip: 'IP', duration: '耗時', startTime: '開始時間',
            },
            copied: '已複製',
            searchEmail: '搜尋使用者信箱',
        },
        usage: {
            config: {
                title: '全域設定', baseTab: '基礎設定', visitorLimit: '訪客每日限制', accountLimit: '免費使用者限制',
                userTaskConcurrencyLimit: '付費使用者單用戶並發限制',
                globalTaskConcurrencyLimit: '付費使用者全域並發限制',
                freeUserTaskConcurrencyLimit: '免費使用者單用戶並發限制',
                freeGlobalTaskConcurrencyLimit: '免費使用者全域並發限制',
                aiCallsPerMinuteLimit: '模型呼叫每分鐘並發限制',
                aiCallsCurrentCount: '當前 AI 呼叫數（本分鐘）',
                aiCallsCurrentCountUnit: '次',
                save: '儲存設定', hint: '提示：修改後將套用於所有新使用者',
            },
            metrics: {
                totalUsage: '今日總使用', avgUsage: '平均使用次數', avgPerUser: '平均 {n} 次/人',
                activeUsers: '活躍使用者數', activeRate: '{n}% 活躍率',
                exceededUsers: '超限使用者數', exceededRate: '{n}% 超限率',
            },
            date: { today: '今天', yesterday: '昨天', last3days: '最近3天', last7days: '最近7天', placeholder: '選擇日期' },
            toolbar: {
                searchPlaceholder: '搜尋使用者信箱', sortField: '排序欄位', sortOrder: '排序方向',
                sortByCount: '使用次數', sortByUserId: '使用者 ID', sortDesc: '降序', sortAsc: '升序', refresh: '重新整理',
            },
            table: {
                title: '使用者使用量列表', export: '匯出資料', user: '使用者', count: '使用次數',
                limit: '限制', usageRate: '使用率', remaining: '剩餘', status: '狀態', action: '操作',
                copyEmail: '複製電子郵件', copyId: '複製 ID', total: '共 {n} 筆記錄',
                empty: '暫無使用者資料', emptyHint: '等待使用者開始使用對話功能',
            },
            status: { exceeded: '超限', warning: '接近', normal: '正常' },
            customLimit: {
                tag: '自訂',
                setLimit: '設定限制',
                reset: '恢復預設',
                dialogTitle: '設定使用者每日限制',
                user: '使用者',
                dailyLimit: '每日限制',
                remark: '備註',
                remarkPlaceholder: '備註（可選）',
                cancel: '取消',
                confirm: '確認',
                setSuccess: '使用者限制設定成功',
                setFailed: '設定失敗',
                removeSuccess: '已恢復為全域預設限制',
                removeFailed: '操作失敗',
            },
            export: {
                account: '帳號', userId: '使用者ID', company: '公司名稱', count: '使用次數',
                limit: '限制', remaining: '剩餘', status: '狀態',
                success: '匯出成功', filename: '使用者使用統計_{date}.csv',
            },
            copied: '已複製',
        },
        report: {
            refresh: '重新整理',
            timeWindowDefault: '預設 5分鐘',
            timeWindow: {
                '5min': '5分鐘', '30min': '30分鐘', '60min': '60分鐘',
                today: '今天', last7days: '近7天', last30days: '近30天',
                last3months: '近3個月', last6months: '近半年', last1year: '近一年',
                minutes: '{n}分鐘',
            },
            userStatsTitle: '使用者統計',
            taskStatsTitle: '任務統計',
            filters: {
                users: '篩選使用者',
                companies: '篩選公司',
                agents: '篩選Agent類型',
                searchUser: '搜尋使用者信箱',
                searchCompany: '搜尋公司名稱',
                agentTypes: {
                    disclosure: '交底書',
                    patentDraft: '專利申請',
                    prosecution: '審查意見書',
                },
            },
            userMetrics: {
                dau: '日活躍使用者（DAU）',
                mau: '月活躍使用者（MAU）',
                uv: '獨立訪客（UV）',
                pv: '頁面瀏覽量（PV）',
                avgDuration: '平均會話時長',
                avgTokensPerMessage: '次均Token數',
            },
            userCharts: {
                tokenTask: 'Token消耗 & 任務數趨勢',
                dauMau: 'DAU/MAU 趨勢',
                uvPv: 'UV & PV 趨勢',
                avgDuration: '平均會話時長趨勢',
                avgConversations: '人均對話數趨勢',
                avgTokensPerMessage: '次均Token數趨勢',
                tokenLabel: 'Token消耗',
                taskLabel: '任務數',
                dauLabel: '日活（DAU）',
                mauLabel: '月活（MAU）',
                uvLabel: '獨立訪客（UV）',
                pvLabel: '頁面瀏覽量（PV）',
                avgDurationLabel: '平均會話時長',
                avgConversationsLabel: '人均對話數',
                avgTokensPerMessageLabel: '次均Token數',
            },
            metrics: {
                workers: '線上 Worker', activeTasks: '活躍任務',
                successRate: '成功率', totalTasks: '總任務({window})', avgDuration: '平均耗時',
            },
            chart: { title: '任務趨勢', empty: '暫無趨勢資料', total: '總量', success: '成功', failure: '失敗' },
            byType: {
                title: '任務類型分佈', type: '類型', total: '總數',
                success: '成功', failure: '失敗', successRate: '成功率', avgDuration: '平均耗時',
            },
            activeTasks: {
                title: '目前活躍任務', fallback: '降級模式', empty: '目前無活躍任務',
                worker: 'Worker', taskType: '任務類型', runtime: '執行時長', taskId: '任務ID',
            },
        },
        tokenUsage: {
            title: '使用者 Token 使用量列表',
            summary: { users: '使用者數', totalTokens: '總 Token', totalMessages: '總訊息數', totalTasks: '總任務數', avgTokensPerTask: '平均 Token / 任務' },
            filter: {
                timeWindowPlaceholder: '選擇時間窗口', statusPlaceholder: '任務狀態',
                statusAll: '全部狀態', statusSuccess: '成功', statusFailure: '失敗',
                statusStarted: '執行中', statusPending: '等待中',
                searchPlaceholder: '搜尋使用者信箱',
                sortByTokens: 'Total Token', sortByMessages: '訊息數', sortByTasks: '任務數',
                sortDesc: '降序', sortAsc: '升序', refresh: '重新整理',
                expandAll: '展開全部', collapseAll: '折疊全部',
            },
            timeWindow: {
                '5min': '5分鐘', '10min': '10分鐘', '30min': '30分鐘', '1h': '1小時',
                today: '今天', last7days: '最近7天', last30days: '最近30天',
            },
            table: {
                user: '使用者', totalTokens: 'Token 用量', messages: '訊息數', tasks: '任務數',
                conversations: '會話數', conversation: '會話', convTokens: '會話 Token', status: '狀態', ip: 'IP',
                createdAt: '建立時間', empty: '暫無 Token 使用資料',
            },
            pagination: { total: '共 {n} 個使用者' },
            copied: '已複製',
        },
        model: {
            agentSection: 'Agent 主模型設定', agentCount: '{n} 個 Agent',
            taskSection: '任務級模型覆蓋', taskCount: '{n} 項',
            modelLabel: '模型', modelPlaceholder: '搜尋或選擇模型',
            tempLabel: '溫度 ({val})', tempPlaceholder: '溫度', maxTokensPlaceholder: '不限制',
            maxOutput: '最大輸出 {n}', maxTemp: '溫度上限 {n}',
            multimodal: '多模態', thinking: '推理',
            multimodalSupport: '支援多模態', thinkingSupport: '支援推理',
            taskHeader: { task: '任務', model: '模型', temp: '溫度' },
            categories: { drafting: '專利撰寫', prosecution: '答覆文件', rag: '文件處理', image: '圖像分析', general: '通用任務', style: '風格提取' },
            save: '儲存設定', undoEdit: '撤銷編輯', resetDefault: '恢復預設', unsaved: '有未儲存的變更',
            loadFail: '載入模型設定失敗', saveSuccess: '模型設定儲存成功', saveFail: '儲存模型設定失敗',
            undoDone: '已撤銷未儲存的編輯',
            resetConfirmMsg: '將清除所有自訂設定，恢復為系統預設值。此操作不可撤銷。',
            resetConfirmTitle: '確認恢復預設', resetConfirmBtn: '恢復預設', resetCancel: '取消',
            resetSuccess: '已恢復為系統預設設定', resetFail: '恢復預設設定失敗',
        },
        tool: {
            baseTools: '基礎工具（不可設定）', specificTools: '專務工具（可設定）',
            itemCount: '{n} 項', required: '必需', noSpecificTools: '該 Agent 暫無專務工具',
            save: '儲存設定', reset: '重置', unsaved: '有未儲存的變更',
            loadFail: '載入工具設定失敗', saveSuccess: '工具設定儲存成功',
            saveFail: '儲存工具設定失敗', resetDone: '已重置為上次儲存的設定',
        },
        proLimit: {
            title: 'Pro 使用者文件數量限制',
            patentDraftLimit: '專利撰寫限制',
            disclosureLimit: '交底書限制',
            oarLimit: '審查意見限制',
            unit: '篇',
            saveSuccess: 'Pro 文件限制儲存成功',
            saveFail: '儲存失敗',
            loadFail: '載入失敗',
        },
        freeLimit: {
            title: 'Free 使用者文件數量限制',
            totalDocumentLimit: '文件總量限制',
            patentDraftLimit: '專利撰寫限制',
            disclosureLimit: '交底書限制',
            oarLimit: '審查意見限制',
            unit: '篇',
            saveSuccess: 'Free 文件限制儲存成功',
            saveFail: '儲存失敗',
            loadFail: '載入失敗',
        },
        prompt: {
            config: {
                title: 'Langfuse 設定',
                publicKeyLabel: 'Public Key', secretKeyLabel: 'Secret Key', hostLabel: 'Host URL（選填）',
                testConnection: '測試連線', loadPrompts: '載入所有 Prompts',
                checkSync: '檢查同步狀態', batchPush: '批次推送',
                promptNamePlaceholder: '輸入 Prompt 名稱', fetch: '取得',
                missingKeys: '請輸入 Public Key 和 Secret Key',
                connectSuccess: '連線成功！', connectFail: '連線失敗: {msg}',
                loadSuccess: '成功載入 {n} 個 Prompts', loadFail: '載入 Prompts 失敗: {msg}',
                fetchFail: '取得 Prompt 失敗: {msg}', promptNameRequired: '請輸入 Prompt 名稱',
                connectFirst: '請先測試連線', loadFirst: '請先載入前端 Prompts',
            },
            list: {
                title: 'Prompt 管理', count: '共 {n} 個', searchPlaceholder: '搜尋 prompts...',
                loading: '正在載入 Prompts...', empty: '暫無 Prompts 資料', reload: '重新載入',
                colName: '名稱', colType: '類型', colLabels: '標籤',
                colSyncStatus: '同步狀態', colActions: '操作',
                view: '查看', push: '推送', synced: '已同步', unchecked: '未檢查',
            },
            sync: {
                same: '已同步', different: '需更新', frontendOnly: '待推送', backendOnly: '僅後端',
                checkDone: '同步狀態檢查完成！共檢查 {total} 個 - 已同步: {same}, 需更新: {diff}, 待推送: {pending}, 僅後端: {backend}',
                checkFail: '檢查同步狀態失敗: {msg}',
            },
            push: {
                dialogTitle: '推送 Prompts 到後端', selected: '共選擇 {n} 個需要推送的 Prompts',
                overwrite: '覆蓋已存在的 Prompts',
                pushing: '正在分批推送中，每批最多5個 Prompts...',
                cancel: '取消', pushBtn: '推送 ({n})', nothingToPush: '沒有需要推送的 Prompts',
                batchInfo: '正在推送第 {cur}/{total} 批 ({n} 個 Prompts)...',
                batchDone: '第 {n} 批推送完成！成功: {success}, 失敗: {fail}',
                allDone: '所有批次推送完成！總計 - 成功: {success}, 失敗: {fail}, 跳過: {skip}',
                pushFail: '推送失敗: {msg}',
                singleSuccess: '{name} 推送成功！', singleSkipped: '{name} 推送被跳過',
                singleFail: '推送 {name} 失敗: {msg}',
            },
            detail: {
                name: '名稱', type: '類型', version: '版本', labels: '標籤',
                content: 'Prompt 內容：', fetchFail: '取得 Prompt 詳情失敗: {msg}',
            },
        },
        assetStats: {
            totalTemplates: '總模板數',
            totalInstructions: '總指令數',
            totalStyles: '總風格數',
            startDate: '開始日期',
            endDate: '結束日期',
            searchUser: '搜尋使用者信箱',
            user: '使用者',
            templates: '模板數',
            instructions: '指令數',
            styles: '風格數',
            all: '全部',
            today: '今天',
            yesterday: '昨天',
            last7days: '最近7天',
            last30days: '最近30天',
            refresh: '重新整理',
            tableTitle: '資產統計列表',
            empty: '暫無資料',
            copied: '已複製',
            total: '共 {n} 筆記錄',
        },
        documentStats: {
            docGroup: '文件統計',
            assetGroup: '資產統計',
            totalDocuments: '總文件數',
            totalExports: '總匯出次數',
            startDate: '開始日期',
            endDate: '結束日期',
            searchUser: '搜尋使用者信箱',
            searchUserBatch: '信箱或使用者ID，多個用逗號分隔',
            user: '使用者',
            userId: '使用者ID',
            company: '公司',
            email: '電子郵件',
            disclosure: '交底書',
            patentDraft: '專利申請',
            prosecution: '審查意見書',
            totalCount: '總文件數',
            exportCount: '匯出次數',
            templateCount: '模板數',
            instructionCount: '指令數',
            styleCount: '風格數',
            folderCount: '資料夾數',
            totalTemplates: '總模板數',
            totalInstructions: '總指令數',
            totalStyles: '總風格數',
            totalFolders: '總資料夾數',
            all: '全部',
            today: '今天',
            yesterday: '昨天',
            last7days: '最近7天',
            last30days: '最近30天',
            custom: '自訂',
            refresh: '重新整理',
            tableTitle: '資產統計列表',
            empty: '暫無資料',
            copied: '已複製',
            total: '共 {n} 筆記錄',
            userTypeAll: '全部使用者',
            userTypeInternal: '內部使用者',
            userTypeExternal: '外部使用者',
            filterTimeRange: '時間範圍',
            filterUser: '使用者篩選',
            search: '查詢',
            reset: '重置',
            bulkSearch: '批量搜尋',
            bulkSearchHint: '每行一個郵箱，或用逗號、空格分隔',
            uploadFile: '上傳檔案',
            uploadFileHint: '支援 .xlsx / .xls / .csv，第一欄為郵箱',
            dropZoneText: '拖曳 Excel / CSV 檔案到此處，或點擊上傳',
            emailInputPlaceholder: '輸入郵箱，按 Enter 新增',
            recognizedCount: '已識別 {n} 個郵箱',
            clearAll: '清空',
            cancel: '取消',
            emailCount: '{n} 個郵箱',
            importedCount: '已匯入 {n} 個郵箱',
            clearImport: '清除',
            export: '匯出',
            exportAll: '匯出全部',
            exportSelected: '匯出選中',
            selectedCount: '已選 {n} 項',
            exportSuccess: '匯出成功',
            parseError: '檔案解析失敗',
            noEmailFound: '未找到有效郵箱',
        },
        feedback: {
            title: '使用者回饋管理',
            totalCount: '共 {n} 條',
            searchEmail: '搜尋使用者信箱',
            statusPlaceholder: '狀態',
            categoryPlaceholder: '分類',
            priorityPlaceholder: '優先級',
            refresh: '重新整理',
            emptyText: '暫無回饋資料',
            colUser: '使用者',
            colTitle: '標題',
            colCategory: '分類',
            colStatus: '狀態',
            colPriority: '優先級',
            colTime: '提交時間',
            copyEmail: '複製信箱',
            copyId: '複製 ID',
            copyProjectId: '複製 Project ID',
            copied: '已複製',
            paginationTotal: '共 {n} 條',
            status: {
                pending: '待處理',
                processing: '處理中',
                resolved: '已解決',
                closed: '已關閉',
            },
            category: {
                bug: '缺陷',
                suggestion: '建議',
                feature_request: '功能請求',
                other: '其它',
            },
            priority: {
                high: '高',
                medium: '中',
                low: '低',
            },
            drawer: {
                statusLabel: '狀態',
                priorityLabel: '優先級',
                statusPending: '待處理',
                statusProcessing: '處理中',
                statusResolved: '已解決',
                statusClosed: '已關閉',
                priorityHigh: '高',
                priorityMedium: '中',
                priorityLow: '低',
                adopt: '採納',
                noMessages: '暫無訊息記錄',
                replyPlaceholder: '輸入回覆內容，Enter 換行，Ctrl+Enter 傳送...',
                replyHint: 'Ctrl+Enter 快速傳送',
                sendReply: '傳送回覆',
                statusLabelPending: '待處理',
                statusLabelProcessing: '處理中',
                statusLabelResolved: '已解決',
                statusLabelClosed: '已關閉',
                categoryBug: '缺陷',
                categorySuggestion: '建議',
                categoryFeatureRequest: '功能請求',
                categoryOther: '其它',
                priorityHighLabel: '高優先級',
                priorityMediumLabel: '中優先級',
                priorityLowLabel: '低優先級',
            },
        },
        modelConfig: {
            groupLabel: '設定組',
            activeTag: '啟用',
            create: '新建',
            rename: '重新命名',
            delete: '刪除',
            createDialogTitle: '新建設定組',
            nameLabel: '名稱',
            namePlaceholder: '如 GPT優先、經濟模式',
            copyFromLabel: '複製自',
            copyFromPlaceholder: '不複製（空設定）',
            cancel: '取消',
            createBtn: '建立',
            renameDialogTitle: '重新命名設定組',
            renamePlaceholder: '新名稱',
            save: '儲存',
            switchSuccess: '已切換設定組',
            switchFail: '切換設定組失敗',
            nameRequired: '請輸入設定組名稱',
            createSuccess: '設定組建立成功',
            createFail: '建立失敗',
            updateSuccess: '設定組已更新',
            updateFail: '更新失敗',
            deleteConfirmMsg: '確定刪除設定組「{name}」？此操作不可撤銷。',
            deleteConfirmTitle: '刪除設定組',
            deleteConfirmBtn: '刪除',
            deleteSuccess: '設定組已刪除',
            deleteFail: '刪除失敗',
        },
        langfuse: {
            connectionFallback: '連線失敗',
            connectionFailMsg: '連線失敗: {msg}',
            connectFirst: '請先測試連線',
            promptNameRequired: '請輸入 Prompt 名稱',
        },
        payment: {
            totalCount: '總筆數',
            totalAmount: '總金額 (USD)',
            records: '支付記錄',
            total: '共 {n} 條',
            searchPlaceholder: '搜尋信箱/套餐',
            startDate: '開始日期',
            endDate: '結束日期',
            refresh: '重新整理',
            emptyText: '暫無支付記錄',
            user: '使用者',
            plan: '套餐',
            amount: '金額',
            cycle: '週期',
            time: '時間',
            monthly: '月付',
            yearly: '年付',
            loadFailed: '載入支付記錄失敗',
            statsFailed: '載入統計失敗',
        },
        skill: {
            patentOffice: '受理局',
            mode: '模式',
            modeAgent: '完整模式',
            modeCopilot: '輕量模式',
            disclosure: '交底書',
            patentDraft: '專利申請',
            prosecution: '審查意見答覆',
            empty: '暫無資料',
            loadFailed: '載入失敗',
            save: '儲存',
            reset: '重置',
            saveSuccess: '儲存成功',
            saveFailed: '儲存失敗',
            editor: { edit: '編輯', split: '分屏', preview: '預覽' },
        },
        role: {
            searchPlaceholder: '搜尋郵箱',
            search: '搜尋',
            assign: '分配角色',
            email: '郵箱',
            role: '角色',
            assignedBy: '分配人',
            remark: '備註',
            createdAt: '建立時間',
            action: '操作',
            remove: '移除',
            assignTitle: '分配角色',
            cancel: '取消',
            confirm: '確認',
        },
        userDetail: {
            title: '用戶詳情',
            userId: '用戶 ID',
            company: '公司',
            sectionDocStats: '文檔統計',
            sectionTokenUsage: 'Token 用量',
            sectionSessions: '會話記錄',
            sectionUsageLimits: '用量限額',
            disclosure: 'Disclosure',
            patentDraft: 'Patent Draft',
            prosecution: 'Prosecution',
            totalDocs: '文檔總數',
            exports: '匯出',
            templates: '範本',
            instructions: '指令',
            styles: '風格',
            folders: '資料夾',
            totalTokens: 'Token 總量',
            totalMessages: '訊息總數',
            taskCount: '任務數',
            conversationId: '會話',
            tokens: 'Tokens',
            messages: '訊息',
            rounds: '輪次',
            duration: '時長',
            successFailure: '成功 / 失敗',
            startTime: '開始時間',
            chatCount: '對話次數',
            limit: '限額',
            customLimit: '自訂限額',
            remaining: '剩餘',
            exceeded: '已超限',
            normal: '正常',
            noData: '暫無資料',
            copied: '已複製',
        },
    },
};
